export const SurveyStatuses = {
  draft: 'draft',
  open: 'open',
  closed: 'closed',
  archived: 'archived',
};



// WEBPACK FOOTER //
// ./src/models/survey/SurveyStatuses.js